/**
 * Generic technical processing lock of an entity (IDLE = no run holds the row).
 * Same shape as the cw mirror; kept local because a feature must not import from another feature.
 *
 * Mirrors the backend enum {@code com.mvs.backend.core.entity.ProcessingStatusEnum} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum ProcessingStatusEnum {
    IDLE,
    QUEUED,
    PROCESSING,
    FAILED,
}
